/* GHALIA — product detail interactivity (Figma V3 PDP) */

(() => {
  const SEL_FORM = '[data-product-form]';
  const SEL_OPTION = '[data-option-input]';
  const SEL_PRICE = '[data-product-price]';
  const SEL_COMPARE = '[data-product-compare]';
  const SEL_SUBMIT = '[data-product-submit]';
  const SEL_VARIANT_ID = '[data-variant-id]';

  const money = (cents) => {
    if (window.Shopify?.formatMoney) return window.Shopify.formatMoney(cents);
    return (cents / 100).toFixed(2);
  };

  const setMainImage = (src, gallery) => {
    const main = (gallery || document).querySelector('[data-pdp-main-img]');
    if (!main || !src) return;
    const base = src.split('?')[0];
    main.src = `${base}?width=1400`;
    main.srcset = `${base}?width=700 700w, ${base}?width=1100 1100w, ${base}?width=1400 1400w`;
    main.sizes = main.sizes || '(min-width: 1024px) 705px, 100vw';
  };

  const getMediaSrcForIndex = (gallery, index) => {
    const idx = String(index);
    const thumb = gallery.querySelector(`[data-pdp-thumb="${idx}"]`);
    if (thumb?.dataset.fullSrc) return thumb.dataset.fullSrc;
    const dot = gallery.querySelector(`[data-pdp-dot="${idx}"]`);
    return dot?.dataset.fullSrc || '';
  };

  const updateGalleryProgress = (gallery, index, slideCount) => {
    const fill = gallery.querySelector('[data-pdp-progress-fill]');
    if (!fill || slideCount < 1) return;
    const i = Math.max(0, Math.min(slideCount - 1, index));
    fill.style.setProperty('--pdp-slide-count', String(slideCount));
    fill.style.setProperty('--pdp-slide-index', String(i));
  };

  const setActiveMediaInGallery = (gallery, index) => {
    const idx = String(index);
    const thumbs = gallery.querySelectorAll('[data-pdp-thumb]');
    const dots = gallery.querySelectorAll('[data-pdp-dot]');
    const slideCount = Math.max(thumbs.length, dots.length);
    let activeThumb = null;

    thumbs.forEach((t) => {
      const on = t.dataset.pdpThumb === idx;
      t.setAttribute('aria-current', on ? 'true' : 'false');
      if (on) activeThumb = t;
    });
    dots.forEach((d) => {
      d.setAttribute('aria-current', d.dataset.pdpDot === idx ? 'true' : 'false');
    });

    const mediaSrc = getMediaSrcForIndex(gallery, index);
    if (mediaSrc) setMainImage(mediaSrc, gallery);

    updateGalleryProgress(gallery, index, slideCount);

    const maxIdx = slideCount - 1;
    const prevBtn = gallery.querySelector('[data-pdp-prev]');
    const nextBtn = gallery.querySelector('[data-pdp-next]');
    if (prevBtn) prevBtn.disabled = index <= 0;
    if (nextBtn) nextBtn.disabled = index >= maxIdx;

    activeThumb?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    gallery.dataset.pdpActiveIndex = idx;
  };

  const initPdpGalleries = () => {
  document.querySelectorAll('[data-pdp-gallery]').forEach((gallery) => {
    const thumbs = gallery.querySelectorAll('[data-pdp-thumb]');
    const dots = gallery.querySelectorAll('[data-pdp-dot]');
    const slideCount = Math.max(thumbs.length, dots.length);
    if (slideCount < 2) return;

    const maxIndex = () => slideCount - 1;
    const currentIndex = () => parseInt(gallery.dataset.pdpActiveIndex, 10) || 0;
    const goTo = (next) => setActiveMediaInGallery(gallery, Math.max(0, Math.min(maxIndex(), next)));

    gallery.addEventListener('click', (e) => {
      const thumb = e.target.closest('[data-pdp-thumb]');
      if (thumb) {
        e.preventDefault();
        goTo(parseInt(thumb.dataset.pdpThumb, 10));
        return;
      }
      const dot = e.target.closest('[data-pdp-dot]');
      if (dot) {
        e.preventDefault();
        goTo(parseInt(dot.dataset.pdpDot, 10));
      }
    });

    gallery.querySelector('[data-pdp-prev]')?.addEventListener('click', (e) => {
      e.preventDefault();
      goTo(currentIndex() - 1);
    });
    gallery.querySelector('[data-pdp-next]')?.addEventListener('click', (e) => {
      e.preventDefault();
      goTo(currentIndex() + 1);
    });

    const mainMedia = gallery.querySelector('[data-pdp-main-media]');
    if (mainMedia) {
      let touchStartX = 0;
      mainMedia.addEventListener('touchstart', (e) => {
        touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });
      mainMedia.addEventListener('touchend', (e) => {
        const delta = e.changedTouches[0].screenX - touchStartX;
        const rtl = document.documentElement.dir === 'rtl';
        if (Math.abs(delta) < 40) return;
        if (delta < 0) goTo(currentIndex() + (rtl ? -1 : 1));
        else goTo(currentIndex() + (rtl ? 1 : -1));
      }, { passive: true });
    }

    gallery.addEventListener('keydown', (e) => {
      const rtl = document.documentElement.dir === 'rtl';
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        goTo(currentIndex() + (rtl ? 1 : -1));
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        goTo(currentIndex() + (rtl ? -1 : 1));
      }
    });

    setActiveMediaInGallery(gallery, 0);
  });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPdpGalleries);
  } else {
    initPdpGalleries();
  }

  document.querySelectorAll(SEL_FORM).forEach((form) => {
    const productJson = form.querySelector('[data-product-json]');
    if (!productJson) return;
    let product;
    try { product = JSON.parse(productJson.textContent); } catch (_) { return; }

    const optionNames = (product.options || []).map((opt) => (typeof opt === 'string' ? opt : opt.name));

    const selectedOptionsByName = () => {
      const map = {};
      form.querySelectorAll(SEL_OPTION).forEach((input) => {
        if (input.type !== 'hidden' && !input.checked) return;
        const match = String(input.name || '').match(/^options\[(.*)\]$/);
        if (!match) return;
        map[match[1]] = input.value;
      });
      return map;
    };

    const findVariant = (selectedByName) => {
      const constrained = optionNames.filter((name) => Object.prototype.hasOwnProperty.call(selectedByName, name));
      if (constrained.length === 0) {
        const currentId = Number(form.querySelector(SEL_VARIANT_ID)?.value);
        return product.variants.find((v) => v.id === currentId)
          || product.variants.find((v) => v.available)
          || product.variants[0];
      }
      return product.variants.find((v) => constrained.every((name) => {
        const idx = optionNames.indexOf(name);
        return idx === -1 || v.options[idx] === selectedByName[name];
      }));
    };

    const updateVariant = () => {
      let variant = findVariant(selectedOptionsByName());

      const root = form.closest('.pdp__info') || form;
      const priceEl = root.querySelector(SEL_PRICE);
      const compareEl = root.querySelector(SEL_COMPARE);
      const saveEl = root.querySelector('[data-product-save-pct]');
      const submitEl = form.querySelector(SEL_SUBMIT);
      const idInput = form.querySelector(SEL_VARIANT_ID);
      const wishlistBtn = form.querySelector('[data-wishlist-toggle]');

      if (!variant) {
        if (submitEl) {
          submitEl.disabled = true;
          submitEl.textContent = submitEl.dataset.unavailable || 'Unavailable';
        }
        return;
      }

      if (idInput) idInput.value = variant.id;
      if (wishlistBtn) wishlistBtn.dataset.variantId = String(variant.id);
      if (priceEl) priceEl.textContent = money(variant.price);
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = money(variant.compare_at_price);
          compareEl.hidden = false;
        } else {
          compareEl.textContent = '';
          compareEl.hidden = true;
        }
      }

      if (saveEl) {
        const compare = Number(variant.compare_at_price) || 0;
        const price = Number(variant.price) || 0;
        const savePct = compare > price && price > 0
          ? Math.round(((compare - price) * 100) / compare)
          : 0;
        if (savePct > 0) {
          const template = saveEl.getAttribute('data-save-template') || '-__PCT__%';
          saveEl.textContent = template.replace('__PCT__', String(savePct));
          saveEl.hidden = false;
        } else {
          saveEl.textContent = '';
          saveEl.hidden = true;
        }
      }
      if (submitEl) {
        if (variant.available) {
          submitEl.disabled = false;
          submitEl.textContent = submitEl.dataset.addToBag || 'Add to bag';
        } else {
          submitEl.disabled = true;
          submitEl.textContent = submitEl.dataset.soldOut || 'Sold out';
        }
      }

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);

      if (form.dataset.productMediaSwap === 'true' && variant.featured_image) {
        const gallery = document.querySelector('[data-pdp-gallery]');
        setMainImage(`${variant.featured_image.src.split('?')[0]}?width=1400`, gallery);
      }
    };

    form.addEventListener('change', (e) => {
      if (e.target.matches(SEL_OPTION)) updateVariant();
    });
    updateVariant();
  });

  /* PDP tabs */
  document.querySelectorAll('[data-pdp-tabs]').forEach((root) => {
    const tabs = root.querySelectorAll('[data-pdp-tab]');
    const panels = root.querySelectorAll('[data-pdp-panel]');

    const activateTab = (id) => {
      tabs.forEach((t) => {
        const active = t.dataset.pdpTab === id;
        t.classList.toggle('is-active', active);
        t.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      panels.forEach((panel) => {
        const active = panel.dataset.pdpPanel === id;
        panel.classList.toggle('is-active', active);
        if (active) panel.removeAttribute('hidden');
        else panel.setAttribute('hidden', '');
        panel.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
    };

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => activateTab(tab.dataset.pdpTab));
    });

    const initial = root.querySelector('[data-pdp-tab].is-active')?.dataset.pdpTab
      || tabs[0]?.dataset.pdpTab;
    if (initial) activateTab(initial);
  });

  /* PDP material swatches — update label + navigate to sibling SKU */
  document.querySelectorAll('[data-pdp-material]').forEach((root) => {
    const labelEl = root.querySelector('[data-pdp-material-label]');
    const swatches = root.querySelectorAll('[data-swatch], [data-sibling-swatch]');
    if (!labelEl || !swatches.length) return;

    const setActiveSwatch = (activeBtn) => {
      swatches.forEach((btn) => {
        const isActive = btn === activeBtn;
        btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        if (isActive) btn.setAttribute('aria-current', 'true');
        else btn.removeAttribute('aria-current');
      });
      const display = activeBtn.dataset.materialDisplay || activeBtn.dataset.siblingMaterial || '';
      if (display) labelEl.textContent = display;
    };

    swatches.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        if (btn.dataset.siblingSwatch != null) e.preventDefault();
        setActiveSwatch(btn);
        const url = btn.dataset.siblingUrl;
        if (url) window.location.href = url;
      });
    });

    const currentSwatch = root.querySelector(
      '[data-swatch][aria-current="true"], [data-swatch][aria-pressed="true"]'
    ) || swatches[0];
    if (currentSwatch) setActiveSwatch(currentSwatch);
  });

  /* Ring size detail line (EU + label) — EN + AR variant strings */
  const normalizeSizeLabel = (labelRaw) => {
    if (!labelRaw) return '';
    const raw = labelRaw.trim();
    const compact = raw.toLowerCase().replace(/\s+/g, '');
    if (/^(xs[-–]?small|xsmall|x-small|xs)$/.test(compact)) return 'XSmall';
    if (raw.includes('-')) {
      const first = raw.split('-')[0].trim().toLowerCase();
      if (first === 'xs') return 'XSmall';
      return raw.split('-').pop().trim();
    }
    return raw;
  };

  const parseRingSizeValue = (raw) => {
    if (!raw || typeof raw !== 'string') return { us: '', eu: '', label: '' };
    const segments = raw.split('(').filter((p) => p.length);
    if (segments.length < 2) return { us: raw, eu: '', label: '' };
    const us = (segments[0].split(')')[1] || '').trim().split('/')[0].trim();
    const labelRaw = segments[segments.length - 1].replace(/\)\s*$/, '').trim();
    const euPart = segments[segments.length - 2] || '';
    const eu = (euPart.split(')')[1] || '').trim().match(/\d{2,3}/)?.[0] || '';
    let label = normalizeSizeLabel(labelRaw);
    if (us === '5' && eu === '50' && /^small$/i.test(label)) label = 'XSmall';
    return { us, eu, label };
  };

  const formatSizeDetail = (template, replacements) => {
    let out = template;
    Object.keys(replacements).forEach((key) => {
      out = out.replace(new RegExp(`\\{\\{\\s*${key}\\s*\\}\\}`, 'g'), replacements[key] || '');
    });
    return out;
  };

  const hydrateRingSizeInputs = (block) => {
    block.querySelectorAll('input[type="radio"]').forEach((input) => {
      const parsed = parseRingSizeValue(input.value);
      if (parsed.eu) input.dataset.sizeEu = parsed.eu;
      if (parsed.us) input.dataset.sizeUs = parsed.us;
      if (parsed.label) input.dataset.sizeLabel = parsed.label;
      const pill = input.closest('label')?.querySelector('.option-pill');
      if (pill && parsed.eu) pill.textContent = parsed.eu;
    });
  };

  document.querySelectorAll('[data-pdp-ring-size]').forEach((block) => {
    const detail = block.querySelector('[data-pdp-size-detail]');
    if (!detail) return;
    let usTemplate = detail.dataset.usTemplate || 'US {{ us_size }} · {{ size_label }}';
    if (/translation missing/i.test(usTemplate)) {
      usTemplate = 'US {{ us_size }} · {{ size_label }}';
    }

    hydrateRingSizeInputs(block);

    const updateDetail = () => {
      const input = block.querySelector('input[type="radio"]:checked');
      if (!input) {
        detail.textContent = '';
        return;
      }
      let eu = input.dataset.sizeEu;
      let us = input.dataset.sizeUs;
      let label = input.dataset.sizeLabel;
      if (!eu || !us || !label) {
        const parsed = parseRingSizeValue(input.value);
        eu = eu || parsed.eu;
        us = us || parsed.us;
        label = label || parsed.label;
      }
      detail.textContent = (us && label)
        ? formatSizeDetail(usTemplate, { us_size: us, size_label: label })
        : '';
      detail.setAttribute('dir', 'auto');
    };

    block.addEventListener('change', updateDetail);
    updateDetail();
  });

  /* Product recommendations section fetch */
  const recRoot = document.querySelector('[data-pdp-recommendations][data-url]');
  if (recRoot && !recRoot.querySelector('.featured-collection__grid')) {
    fetch(recRoot.dataset.url)
      .then((r) => r.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('[data-pdp-recommendations]');
        if (fresh?.innerHTML.trim()) recRoot.innerHTML = fresh.innerHTML;
      })
      .catch(() => {});
  }
})();
